import { render, staticRenderFns } from "./ComposerRow.vue?vue&type=template&id=ce840a64&scoped=true"
import script from "./ComposerRow.vue?vue&type=script&lang=js"
export * from "./ComposerRow.vue?vue&type=script&lang=js"
import style0 from "./ComposerRow.vue?vue&type=style&index=0&id=ce840a64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce840a64",
  null
  
)

export default component.exports